import Log from '../../common/log';
import { SessionsTag } from '../../common/Constants';
/**
 * Manages the request queue with backpressure
 */
export default class RequestQueue {
    constructor(maxSize = 50) {
        this.requests = [];
        this.maxSize = maxSize;
    }
    /**
     * Enqueue a request
     * @param request - Request to enqueue
     * @returns true if enqueued, false if dropped due to backpressure
     */
    enqueue(request) {
        if (this.requests.length >= this.maxSize) {
            Log.warn(SessionsTag, `Too many requests waiting for token (${this.requests.length}/${this.maxSize}), dropping request`);
            return false;
        }
        this.requests.push(request);
        return true;
    }
    /**
     * Dequeue and return the first request
     * @returns The first request or undefined if queue is empty
     */
    dequeue() {
        return this.requests.shift();
    }
    /**
     * Peek at the first request without removing it
     * @returns The first request or undefined if queue is empty
     */
    peek() {
        return this.requests[0];
    }
    /**
     * Add a request to the beginning of the queue
     * @param request - Request to add
     */
    unshift(request) {
        this.requests.unshift(request);
    }
    /**
     * Check if queue is empty
     */
    isEmpty() {
        return this.requests.length === 0;
    }
    /**
     * Get current queue size
     */
    size() {
        return this.requests.length;
    }
    /**
     * Clear all requests
     */
    clear() {
        this.requests = [];
    }
    /**
     * Update max size
     * @param maxSize - New maximum size
     */
    setMaxSize(maxSize) {
        if (typeof maxSize === 'number' && maxSize > 0) {
            this.maxSize = maxSize;
        }
    }
    /**
     * Get max size
     */
    getMaxSize() {
        return this.maxSize;
    }
    /**
     * Get all requests (for internal/legacy use)
     * @internal
     */
    getRequests() {
        return this.requests;
    }
}
